import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/quora': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M440.5 386.7c1.8 18-7.2 93.3-89 93.3-49.5 0-75.5-28.7-95.2-62.3-117.7 32.6-249-54.9-249-189 0-117 98-196.7 197.7-196.7 101.8 0 198.5 79.2 198.4 196.7 0 65.5-30.5 118.8-74.7 153 14.2 21.6 29 35.8 49.5 35.8 22.5 0 31.5-17.3 33-30.8h29.3zM297 329.2c11.3-24.9 16.8-58.7 16.7-100.5 0-104.2-32.5-157.7-108.7-157.7-75 0-107.5 53.5-107.5 157.9 0 103.7 32.5 156.7 107.5 156.7 12 0 22.7-1.2 32.7-4.2-15.5-30.5-33.7-61.3-69.2-61.3-6.8 0-13.6 1-19.8 4l-12.2-24.3c14.7-12.8 38.5-22.8 69-22.8 47.8 0 72 23 91.5 52.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/quora.js
// module id = 982
// module chunks = 0